<div class="app-verification-container">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <div class="flex justify-content-between flex-wrap card-container purple-container">
                <div class="flex align-items-center justify-content-center">
                    <!-- <h5 class="mt-0">{{'FARMER_APPLICATION_HEADER'| translate}}</h5> -->
                </div>
                <div class="flex align-items-center justify-content-center">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help m-3"></button>
                        <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                      class="p-button-info ml-3"></button>
                        <p-menu #menu [popup]="true"  [model]="appVerificationItems"></p-menu>
                </div>
            </div>
            <p-table #vendorTable [value]="vendorData" [rows]="10" [paginator]="true"
                [globalFilterFields]="['srNo', 'AppID','ProgrammeName', 'farmerName','Village', 'block', 'district',  'Mobile', 'Address', 'dt_reg', 'Total_Area', 'Current_Status','Remarks','Status']"
                responsiveLayout="scroll" [(selection)]="vendorData" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                [showCurrentPageReport]="true" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_HEADER'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="vendorTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="srNo">{{'SR_NO'| translate}}
                            <p-columnFilter type="text" field="srNo" display="menu"></p-columnFilter>
                            <p-sortIcon field="srNo"></p-sortIcon>
                        </th>

                        <th pSortableColumn="AppID">{{'APP_ID'| translate}}
                            <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppID"></p-sortIcon>
                        </th>

                        <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                            <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                            <p-sortIcon field="ProgrammeName"></p-sortIcon>
                        </th>

                        <th pSortableColumn="farmerName">{{'FARMER_NAME'| translate}}
                            <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="farmerName"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>

                        <th pSortableColumn="block">{{'BLOCK'| translate}}
                            <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                            <p-sortIcon field="block"></p-sortIcon>
                        </th>

                        <th pSortableColumn="district">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                            <p-sortIcon field="district"></p-sortIcon>
                        </th>



                        <th pSortableColumn="Mobile">{{'MOBILE'| translate}}
                            <p-columnFilter type="text" field="Mobile" display="menu"></p-columnFilter>
                            <p-sortIcon field="Mobile"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Address">{{'ADDRESS'| translate}}
                            <p-columnFilter type="text" field="Address" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address"></p-sortIcon>
                        </th>

                        <th pSortableColumn="dt_reg_sort">{{'DATE_OF_REG'| translate}}
                            <p-columnFilter type="text" field="dt_reg" display="menu"></p-columnFilter>
                            <p-sortIcon field="dt_reg_sort"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Total_Area">{{'TOTAL_AREA'| translate}}
                            <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Total_Area"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Current_Status">{{'CURRENT_STATUS'| translate}}
                            <p-columnFilter type="text" field="Current_Status" display="menu"></p-columnFilter>
                            <p-sortIcon field="Current_Status"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Remarks">{{'REMARKS'| translate}}
                            <p-columnFilter type="text" field="Remarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="Remarks"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Status">{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status"></p-sortIcon>
                        </th>

                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{product.srNo}}</td>
                        <td>{{product.AppID}}</td>
                        <td>{{product.ProgrammeName}}</td>
                        <td>{{product.farmerName}}</td>
                        <td>{{product.Village}}</td>
                        <td>{{product.block}}</td>
                        <td>{{product.district}}</td>
                        <td>{{product.Mobile}}</td>
                        <td>{{product.Address}}</td>
                        <td>{{product.dt_reg}}</td>
                        <td>{{product.Total_Area}}</td>
                        <td>{{product.Current_Status}}</td>
                        <td>{{product.Remarks}}</td>
                        <td>{{product.Status}}</td>
                    </tr>
                </ng-template>

            </p-table>
        </div>
    </p-card>
</div>
